/**
 * AxLabs Chemistry Experiments - Generated Exports
 *
 * All generated chemistry experiments exported as arrays.
 */
// Physical chemistry experiments
export { VaporPressureClausiusClapeyron, RaoultsLawIdealMixture, BoilingPointElevation, FreezingPointDepression, OsmoticPressure, HenrysLaw, PhaseDiagramWaterLike, ColligativeProperties, } from './physical-chemistry.js';
// Electrochemistry experiments
export { GalvanicCellNernst, ElectrolysisFaraday, ConcentrationCell, pHElectrodeCalibration, ConductivityTitration, ElectroplatingRate, } from './electrochemistry.js';
// Thermochemistry experiments
export { HesssLawVerification, BombCalorimetry, EnthalpyOfNeutralization, EnthalpyOfSolution, } from './thermochemistry.js';
// ============================================================================
// EXPERIMENT ARRAYS BY CATEGORY
// ============================================================================
import { VaporPressureClausiusClapeyron, RaoultsLawIdealMixture, BoilingPointElevation, FreezingPointDepression, OsmoticPressure, HenrysLaw, PhaseDiagramWaterLike, ColligativeProperties, } from './physical-chemistry.js';
import { GalvanicCellNernst, ElectrolysisFaraday, ConcentrationCell, pHElectrodeCalibration, ConductivityTitration, ElectroplatingRate, } from './electrochemistry.js';
import { HesssLawVerification, BombCalorimetry, EnthalpyOfNeutralization, EnthalpyOfSolution, } from './thermochemistry.js';
/**
 * All physical chemistry experiments
 */
export const physicalChemistryExperiments = [
    VaporPressureClausiusClapeyron,
    RaoultsLawIdealMixture,
    BoilingPointElevation,
    FreezingPointDepression,
    OsmoticPressure,
    HenrysLaw,
    PhaseDiagramWaterLike,
    ColligativeProperties,
];
/**
 * All electrochemistry experiments
 */
export const electrochemistryExperiments = [
    GalvanicCellNernst,
    ElectrolysisFaraday,
    ConcentrationCell,
    pHElectrodeCalibration,
    ConductivityTitration,
    ElectroplatingRate,
];
/**
 * All thermochemistry experiments
 */
export const thermochemistryExperiments = [
    HesssLawVerification,
    BombCalorimetry,
    EnthalpyOfNeutralization,
    EnthalpyOfSolution,
];
/**
 * All generated chemistry experiments
 */
export const allChemistryExperiments = [
    ...physicalChemistryExperiments,
    ...electrochemistryExperiments,
    ...thermochemistryExperiments,
];
/**
 * Total count of generated experiments
 */
export const experimentCount = {
    physicalChemistry: physicalChemistryExperiments.length,
    electrochemistry: electrochemistryExperiments.length,
    thermochemistry: thermochemistryExperiments.length,
    total: allChemistryExperiments.length,
};
//# sourceMappingURL=index.js.map